export default __webpack_public_path__ + "static/media/1.824e0ad1.png";